import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import './ProductGrid.css';

const ProductGrid = ({ products, onAddToCart, onProductClick }) => {
  const { t } = useLanguage();

  const toTranslationKey = (value = '') => value
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  const getTranslatedCategory = (category) => (
    t(`bhaktiStore.categories.${toTranslationKey(category)}`, {}, category)
  );

  const getTranslatedProductName = (product) => (
    t(`bhaktiStore.products.${toTranslationKey(product?.name)}.name`, {}, product?.name || '')
  );

  const isOutOfStock = (product) => {
    const stock = Number(product?.stock);
    return Number.isFinite(stock) && stock <= 0;
  };

  return (
    <section className="product-grid-section">
      <div className="container">
        {products.length === 0 ? (
          <p className="no-products-message">{t('bhaktiStore.messages.noProductsInCategory')}</p>
        ) : (
          <div className="product-grid">
            {products.map((product) => {
              const outOfStock = isOutOfStock(product);
              return (
                <motion.div
                  key={product._id}
                  className="product-card"
                  // ... motion props ...
                >
                  <div className="product-image-container" onClick={() => onProductClick(product)}>
                    <img src={product.images[0]} alt={getTranslatedProductName(product)} className="product-image" />
                  </div>
                  <div className="product-info">
                    {/* --- UPDATE THIS H3 ELEMENT --- */}
                    <h3
                      className="product-name"
                      onClick={() => onProductClick(product)}
                      data-full-name={getTranslatedProductName(product)} /* <-- Add this attribute */
                    >
                      {getTranslatedProductName(product)}
                    </h3>
                    {/* ----------------------------- */}
                    <p className="product-category">{getTranslatedCategory(product.category)}</p>
                    <div className="product-price">₹{product.price.toFixed(2)}</div>
                    <button
                      className={`btn-add-to-cart ${outOfStock ? 'disabled' : ''}`}
                      onClick={() => onAddToCart(product)}
                      disabled={outOfStock}
                      aria-disabled={outOfStock}
                    >
                      {outOfStock ? t('bhaktiStore.actions.outOfStock') : t('bhaktiStore.actions.addToCart')}
                    </button>
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductGrid;
